var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasticsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6076,
    cy: 70.3727,
    r: 69.7345,
    fill: "#E6F0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.928 94.0217H70.6074L74.6784 79.8884H110.088L114.928 94.0217Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.244 105.774H76.2915L70.6074 94.0215H114.928L109.244 105.774Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4453 90.3347H109.55",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3932 105.62H35.7339L32.5078 56.384H61.6193L58.3932 105.62Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9246 52.9272H30.2812V56.3838H63.9246V52.9272Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6288 38.5637V52.9274H52.1723V37.8724C52.1723 37.8724 51.9418 35.7217 54.8607 35.7217H69.5316V38.5637H55.7824",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6288 38.5637V52.9274H52.1723V37.8724C52.1723 37.8724 51.9418 35.7217 54.8607 35.7217H69.5316V38.5637H55.7824",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6472 49.8549V73.5128H74.6777V49.8549C74.6777 42.481 79.3632 36.4897 85.2009 36.4897H105.94",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6472 49.8549V73.5128H74.6777V49.8549C74.6777 42.481 79.3632 36.4897 85.2009 36.4897H105.94",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.17 63.2202H95.6465",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.17 63.2201C111.981 63.2201 116.693 57.2363 116.693 49.8549C116.693 42.4735 111.981 36.4897 106.17 36.4897C100.358 36.4897 95.6465 42.4735 95.6465 49.8549C95.6465 57.2363 100.358 63.2201 106.17 63.2201Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.477 54.4636C108.428 54.4636 110.01 52.469 110.01 50.0085C110.01 47.5481 108.428 45.5535 106.477 45.5535C104.525 45.5535 102.943 47.5481 102.943 50.0085C102.943 52.469 104.525 54.4636 106.477 54.4636Z",
    stroke: "#135040",
    strokeWidth: 1.53623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticsLogo);
export default __webpack_public_path__ + "static/media/plastics-logo.836e6d9bc8ac04d965f14af23fd69aed.svg";
export { ForwardRef as ReactComponent };